import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { CheckIcon, NotIcon, PatientStatusOptions, QuestionmarkIcon } from '@dreryk/react-components';

import {
   PatientEntitlementToMedicalServiceStatusVerificationFailureType,
   PatientEntitlementToMedicalServiceStatusVerificationResultType,
} from '~libs.shared.patient-entitlement-to-medical-service';

export const usePatientEntitlementToMedicalServiceStatusOptions = (): PatientStatusOptions<
   Record<
      | PatientEntitlementToMedicalServiceStatusVerificationResultType
      | PatientEntitlementToMedicalServiceStatusVerificationFailureType,
      {
         icon: JSX.Element;
         backgroundColor: string;
      }
   >
> => {
   const theme = useTheme();
   return useMemo(() => {
      return {
         INSURED: {
            icon: <CheckIcon />,
            backgroundColor: theme.success,
         },
         UNINSURED: {
            icon: <NotIcon />,
            backgroundColor: theme.error,
         },
         ACCOUNT_LOGIN_ERROR: {
            icon: <QuestionmarkIcon />,
            backgroundColor: theme.warning,
         },
         PASSWORD_EXPIRED: {
            icon: <QuestionmarkIcon />,
            backgroundColor: theme.warning,
         },
         ACCOUNT_BLOCKED: {
            icon: <QuestionmarkIcon />,
            backgroundColor: theme.warning,
         },
         VERIFICATION_FAILURE: {
            icon: <QuestionmarkIcon />,
            backgroundColor: theme.warning,
         },
         UNVERIFIED_WITHOUT_EXTERNAL_IDENTIFIER: {
            icon: <QuestionmarkIcon />,
            backgroundColor: theme.background,
         },
         UNVERIFIED_IN_FUTURE: {
            icon: <QuestionmarkIcon />,
            backgroundColor: theme.background,
         },
         UNVERIFIED: {
            icon: <QuestionmarkIcon />,
            backgroundColor: theme.background,
         },
         VALID_ENTITLEMENT_STATEMENT: {
            icon: <CheckIcon />,
            backgroundColor: theme.info,
         },
      };
   }, [theme]);
};
